import { render, staticRenderFns } from "./ModalConfirmOrder.vue?vue&type=template&id=dc5d046a"
import script from "./ModalConfirmOrder.vue?vue&type=script&lang=js"
export * from "./ModalConfirmOrder.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmOrder.vue?vue&type=style&index=0&id=dc5d046a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports